export const JADWAL_GET = 'JADWAL_GET';